import { render, staticRenderFns } from "./MedSurveyPages.vue?vue&type=template&id=67eb521a&scoped=true&"
import script from "./MedSurveyPages.vue?vue&type=script&lang=js&"
export * from "./MedSurveyPages.vue?vue&type=script&lang=js&"
import style0 from "./MedSurveyPages.vue?vue&type=style&index=0&id=67eb521a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67eb521a",
  null
  
)

export default component.exports